import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { canAccessRoute } from 'constant/role-routes';
import { useCommonStore } from 'state/store/common/useCommonStore';

export function RoleRouteGuard() {
  const { pathname } = useLocation();
  const user = useCommonStore((state) => state.user);

  if (user && !canAccessRoute(pathname, user.roles ?? [])) {
    return <Navigate to="/chat" replace />;
  }

  return <Outlet />;
}
